


































import { Component, Prop, Emit, Vue } from "vue-property-decorator";

interface Item {
  text?: string;
  value?: string;
  header?: string;
  divider?: boolean;
  [key: string]: unknown;
}

@Component
export default class SameBuildingGroupSelect extends Vue {
  /** 選択中の値 */
  @Prop({ default: "" }) value!: string;
  /** 選択肢 */
  @Prop({ default: () => [] }) items!: Item[];
  /** 非活性フラグ */
  @Prop({ default: false }) disabled!: boolean;
  /** ラベル */
  @Prop({ default: "同一建物・同一建物グループ" }) label!: string;
  /** 検索ヒット */
  @Prop({ default: "該当する建物・グループが見つかりません" })
  noDataText!: string;
  /** 横幅 */
  @Prop({ default: "100%" }) width!: string;
  /** 最小横幅 */
  @Prop({ default: "225px" }) minWidth!: string;
  /** 高さ */
  @Prop({ default: "48px" }) height!: string;
  /** key 用プレフィックス */
  @Prop({ default: "sbg" }) keyPrefix!: string;
  /** バリデーションルール */
  @Prop({ default: () => [] }) rules!: ((
    v: string | null
  ) => boolean | string)[];

  private get autocompleteKey(): string {
    return `${this.keyPrefix}-${this.items.length}`;
  }

  // フィルター
  private filterWithHeaders(
    item: Item,
    queryText: string,
    itemText: string
  ): boolean {
    if (item.header || item.divider) return true;
    const text = itemText || item.text || "";
    return text.toLowerCase().includes((queryText || "").toLowerCase());
  }

  @Emit("input")
  private onInput(value: string | null): string | null {
    return value;
  }
}
